import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

/**
   * Funcion que permite subir terminos y condiciones en formato PDF
   * @param {*} file - Contenido del archivo pdf
   * @author KenzoSashida
   * @version 1.0.0 - Julio 2024
*/

const uploadFileTermsAndConditions = async(file)=>{
    const formData = new FormData()
    formData.append('file', file)
    const url = `${baseUrl}/slider/upload`;
    const token = await authHeader()
    const response = await axios.post(url, formData, {
        headers: token,
        "Content-Type" : "multipart/form-data"
        
    })
    return response.data
}

const getFileTermsAndConditions = async ()=>{
    const url = `${baseUrl}/slider/pdf`
    
    const response = await axios.get(url)
    return response.data
}
const getPrivacyAdvertice = async ()=>{
        const url = `${baseUrl}/slider/pdf-privacy?version=v1`
       const token = await authHeader()
    const response = await axios.get(url,{headers:token})
    return response.data
}
export default {
    uploadFileTermsAndConditions,
    getFileTermsAndConditions,
    getPrivacyAdvertice
}